import { Component } from '@angular/core';

@Component({
  selector: 'app-signup-thank-you',
  standalone: true,
  imports: [],
  templateUrl: './signup-thank-you.component.html',
  styleUrl: './signup-thank-you.component.scss'
})
export class SignupThankYouComponent {

}
